import {
  Box,
  Button,
  Checkbox,
  Flex,
  Heading,
  Icon,
  List,
  ListIcon,
  ListItem,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { useContext, useEffect, useState } from 'react'
import { RiAddLine, RiCheckLine, RiDeleteBin6Line, RiPencilLine } from 'react-icons/ri'
import { useMutation } from 'react-query'
import { Link } from 'react-router-dom'
import { Modal } from '../../components/Modal'
import { Pagination } from '../../components/Pagination'
import { SearchContext } from '../../context/SearchContext'
import { Client } from '../../Interfaces/client'
import { api } from '../../services/api'
import { useClients } from '../../services/hooks/useClients'

export function Clients() {
  const { searchValue } = useContext(SearchContext)
  const toast = useToast()

  const [page, setPage] = useState(1)

  const { queryContextParams, clearQuery } = useContext(SearchContext)

  const { data, isLoading, isFetching, error, refetch } = useClients<Client[]>({
    isSelect: false,
    page,
    ...queryContextParams,
  })

  const { isOpen, onOpen, onClose } = useDisclosure()

  const [currentClient, setCurrentClient] = useState<Client>()

  useEffect(() => {
    refetch()
  }, [queryContextParams])

  useEffect(() => {
    return () => {
      clearQuery()

      refetch()
    }
  }, [])

  const handleRemoveButton = () => {
    if (currentClient) removeProvider.mutateAsync(currentClient)

    onClose()
  }

  const removeProvider = useMutation(
    async (client: Client) => {
      const response = await api.delete(`clients/${client.id}`)

      if (response) {
        toast({ description: 'Removido com sucesso', status: 'success' })
        refetch()
      }

      onClose()
      return response.data
    },
    {
      onError: ({ response }) => {
        const errorList = response.data.errors

        const toastOptions = errorList.map((err) => ({ description: err.message, status: 'error' }))
        toastOptions.forEach((t) => {
          toast(t)
        })
      },
    },
  )

  const handleModalOpen = (client) => {
    setCurrentClient(client)

    onOpen()
  }

  // Removido filtro local - o filtro deve ser aplicado no servidor via queryContextParams

  return (
    <Box flex="1" borderRadius="8" bg="gray.800" p="8">
      <Flex mb="8" justifyContent="space-between" align="center">
        <Heading size="lg" fontWeight="normal">
          Clientes
          {!isLoading && isFetching && <Spinner size="sm" color="gray.500" ml="4" />}
        </Heading>

        <Button
          as={Link}
          to="/clients/create"
          size="sm"
          fontSize="sm"
          colorScheme="pink"
          leftIcon={<Icon as={RiAddLine} fontSize="20" />}>
          Criar Novo
        </Button>
      </Flex>

      {isLoading ? (
        <Flex justify="center">
          <Spinner />
        </Flex>
      ) : error ? (
        <Flex justify="center">
          <Text>Falha ao obter os clientes</Text>
        </Flex>
      ) : (
        <Table colorScheme="whiteAlpha">
          <Thead>
            <Tr>
              <Th px={['4', '4', '6']} color="gray.300" width="8">
                <Checkbox colorScheme="pink" />
              </Th>
              <Th>Nome</Th>
              <Th>Telefone</Th>
              <Th>E-mail</Th>
              <Th width="4" />
              <Th width="4" />
            </Tr>
          </Thead>
          <Tbody>
            {data?.clients.map((client: Client) => {
              return (
                <Tr key={client.id}>
                  <Td px={['4', '4', '6']}>
                    <Checkbox colorScheme="pink" />
                  </Td>
                  <Td>
                    <Box>
                      <Text fontWeight="bold">{client.name}</Text>
                      <Text fontSize="small" color="gray.300">
                        {client.cnpj}
                      </Text>
                    </Box>
                  </Td>

                  <Td>{client.phone}</Td>
                  <Td>{client.email}</Td>
                  <Td>
                    <Button
                      as={Link}
                      to={`/clients/edit/${client.id}`}
                      size="sm"
                      fontSize="sm"
                      colorScheme="purple"
                      leftIcon={<Icon as={RiPencilLine} />}>
                      Editar
                    </Button>
                  </Td>
                  <Td>
                    <Button
                      onClick={() => handleModalOpen(client)}
                      size="sm"
                      fontSize="sm"
                      colorScheme="red"
                      leftIcon={<Icon as={RiDeleteBin6Line} />}>
                      Remover
                    </Button>
                  </Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      )}

      <Pagination totalCountOfRegisters={data?.totalCount} currentPage={page} onPageChange={setPage} />

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Remover Fornecedor"
        buttonTitle="Remover"
        buttonAction={handleRemoveButton}>
        <List spacing={3}>
          <ListItem>
            <ListIcon as={RiCheckLine} color="green.500" />
            {`Nome: ${currentClient?.name}`}
          </ListItem>
          <ListItem>
            <ListIcon as={RiCheckLine} color="green.500" />
            {`CNPJ: ${currentClient?.cnpj}`}
          </ListItem>
        </List>
      </Modal>
    </Box>
  )
}
